// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nH-z","twoColumnImage":"oH-z"};